
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';
import { NotificationsService } from 'angular2-notifications';

import { PessoaService } from 'app/shared/pessoa/pessoa.service';
import { AlterarSenhaService } from './alterar-senha.service';
import { AuthenticationService } from 'app/core/authentication/authentication.service';

@Component({
  selector: 'app-alterar-senha',
  templateUrl: './alterar-senha.component.html',
  styleUrls: ['./alterar-senha.component.scss'],
})
export class AlterarSenhaComponent implements OnInit, OnDestroy {

  public senha: string;
  public senhaConfirmar: string;
  public erro = false;
  public erroMsg = '';
  public carregandoLogin = false;
  private redirecionarPara: string;
  private subsRota: Subscription;
  private subsAlterarPessoa: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private pessoaService: PessoaService,
    private alterarSenhaService: AlterarSenhaService,
    private notificacao: NotificationsService,
  ) {}

  ngOnInit() {
    this.subsRota = this.route
      .queryParams
      .subscribe(params => {
        this.redirecionarPara = params['redirectUrl'];
      });
  }

  alterarSenha(form: NgForm) {
    if (!form.valid) {
      return;
    }
    const { pessoa } = this.authenticationService.getLoggedUser();
    this.carregandoLogin = true;

    const pessoaObservable: Observable<any>  = this.pessoaService.alterarSenha(
      pessoa.codigo,
      this.senha,
      this.alterarSenhaService.senhaParaTroca(),
      null,
      null
    );

    this.subsAlterarPessoa = pessoaObservable.subscribe(() => {
      this.carregandoLogin = false;
      this.notificacao.success('Sucesso', 'Sua senha foi alterada.');
      this.router.navigate([this.redirecionarPara || `/restrito/${pessoa.perfil}`]);
    });

    pessoaObservable.catch((erro) => {
      this.carregandoLogin = false;
      return erro;
    });
  }

  ngOnDestroy() {
    this.subsRota.unsubscribe();
    if (this.subsAlterarPessoa) {
      this.subsAlterarPessoa.unsubscribe();
    }
  }
}
